import React, { useEffect, useState } from 'react';
import { Button, Grid, FormControlLabel, Switch, Checkbox } from '@mui/material';
import Select from 'react-select';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from "react-redux";
import { loadStatus, loadUsers, loadDepartments, loadTeams } from "../../../redux/actions/lookups.action";
import DatePicker from "react-datepicker";
// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import { useSearchParams } from 'react-router-dom';
import { PeriodList } from '../../../utils/PeriodList';
import { axiosFetch } from '../../../utils/AxiosFetch';
import { useNavigate } from 'react-router-dom';


const FilterOKR = (props) => {

    let statusList = useSelector((state) => state.loadStatus_Reducer.statusList);
    let usersList = useSelector((state) => state.loadUsers_Reducer.usersList);
    let teamList = useSelector((state) => state.loadTeam_Reducer.teamList);
    let departmentList = useSelector(state => state.loadDepartment_Reducer.departmentList);


    let period_list = PeriodList(3, "full");



    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [isShowPast_DueDate, setIsShowPast_DueDate] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState([]);
    const [selectedParticipant, setSelectedParticipant] = useState([]);
    // const [departmentList, setDepartmentList] = useState([]);
    // const [teamList, setTeamList] = useState([]);


    const [selectedOwnerId, setSelectedOwnerId] = useState("");
    const [selectedParticipantId, setSelectedParticipantId] = useState("");
    const [selectedDept, setSelectedDept] = useState(null);
    const [selectedTeam, setSelectedTeam] = useState(null);


    const [isDueDatePast, setIsDueDatePast] = useState(searchParams.get("passedDueDate") === "true" ? true : false);
    const [isShowArchive, setIsShowArchive] = useState(false);


    const [startDate, setStartDate] = React.useState((searchParams.get("dueDate") !== null && searchParams.get('dueDate') !== "null") ? new Date(searchParams.get("dueDate")) : "");
    const [keyword, setKeyword] = React.useState("");

    const [isArchived, setIsArchived] = useState(searchParams.get("isArchived") ? searchParams.get("isArchived") === "true" ? true : false : false);
    const [includeKeyResult, setIncludeKeyResult] = useState(searchParams.get("isArchived") ? searchParams.get("includeKR") === "true" ? true : false : false);
    const [isChanged, setIsChanged] = useState(false);



    const handleChangeDepartment = (obj) => {
        setSelectedDept(obj);
        dispatch(loadTeams(parseInt(obj.value)));
    }

    const handleChangeTeam = (obj) => {
        setSelectedTeam(obj);
    }

    const handleSearch = () => {

        if (Array.isArray(selectedStatus)) {
            if (selectedStatus.length !== 0) {
                props.handleChangeStatusId(selectedStatus[0].value);
            }

        }
        else if (selectedStatus !== null) {
            props.handleChangeStatusId(selectedStatus.value);
        }

        if (isChanged) {
            props.toggleIncludeKR(includeKeyResult);
        }
        if (selectedParticipant.length > 0) {
            props.handleChangeParticpantId(selectedParticipant);
        }
        if (selectedOwner.length > 0) {
            props.handleChangeAssignedUserId(selectedOwner);
        }
        if (selectedPeriod !== null) {
            props.handleChangeYear(selectedPeriod.value.split("-")[0]);
            props.handleChangeDateFilter(selectedPeriod.value.split("-")[1]);
        }
        if (startDate !== "") {
            props.handleChangeDueDate(startDate);
        }
        if (keyword !== "") {
            props.handleChangeTitle(keyword);
        }
        if (isArchived) {
            props.handleIsPastDueDate(false);
            props.toggleIncludeKR(false);
            props.handleIsArchive(isArchived);
        }
        if (isDueDatePast) {
            props.handleIsArchive(false);
            props.handleIsPastDueDate(isDueDatePast);
        }
        if (selectedDept !== null) {
            props.handleChangeDepartment(selectedDept.value);
        }
        if (selectedTeam !== null) {
            props.handleChangeTeam(selectedTeam.value);
        }




    }

    const handleChangeIncludeKeyResult = (e) => {
        setIsChanged(true);
        setIncludeKeyResult(e.target.checked);
    }


    const handleChangeParticipant = (arr) => {
        setSelectedParticipant(arr);
        let participantsId;
        if (arr !== null && arr.length !== 0) {
            participantsId = arr.map(arr => arr.value).toString();
            setSelectedParticipantId(participantsId);
        }
        else if (arr === null || arr.length === 0) {
            setSelectedParticipantId(null);
        }
        // props.handleChangeParticpantId(arr);
    }

    const handleChangeOwner = (arr) => {
        setSelectedOwner(arr);
        let ownersId;
        if (arr !== null && arr.length !== 0) {
            ownersId = arr.map(arr => arr.value).toString();
            setSelectedOwnerId(ownersId);
        }
        else if (arr === null || arr.length === 0) {
            setSelectedOwnerId(null);
        }
        // props.handleChangeAssignedUserId(arr);
    }

    const handleChangeStatus = (arr) => {
        setSelectedStatus(arr);
        // props.handlePageChange(1);
        // props.handleChangeStatusId(obj.value);
    }


    const handleChangePeriod = (obj) => {
        setSelectedPeriod(obj);
        // props.handlePageChange(1);
        // props.handleChangeYear(obj.value.split("-")[0]);
        // props.handleChangeDateFilter(obj.value.split("-")[1]);
    }

    const handleChangeDueDate = (date) => {
        if (date) {
            setStartDate(date);
            // props.handlePageChange(1);
            // props.handleChangeDueDate(date);
        }
    }

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value);
    }

    const toggleArchive = (e) => {
        if (e.target.checked === true) {
            setIsDueDatePast(false);
            setIncludeKeyResult(false);
            // setIsArchived(e.target.checked);
        }
        else {
            setIncludeKeyResult(false);
            setIsDueDatePast(false);
        }
        setIsArchived(e.target.checked);
        // props.handlePageChange(1);


    }

    const togglePastDueDate = (e) => {

        if (e.target.checked === true) {
            setIsArchived(false);
            // setIsShowArchive(true);
        }
        else {
            setIsArchived(false);
            // setIsShowArchive(false);
        }
        setIsDueDatePast(e.target.checked);

    }


    const handleClear = () => {
        props.handleChangeTitle(null);
        props.handleChangeDueDate(null);
        props.handleChangeYear(null);
        props.handleChangeDateFilter(null);
        props.handleChangeStatusId(null);
        props.handleChangeAssignedUserId(null);
        props.handleChangeYear(null);
        props.handleChangeDateFilter(null);
        props.handleChangeParticpantId(null)

        window.location.reload();

        props.clearList();

        setKeyword("");
        setSelectedOwner([]);
        setSelectedDept(null);
        setSelectedTeam(null);

        setSelectedStatus(null);
        setSelectedPeriod(null);
        setStartDate("");


        setIsArchived(false);
        setSelectedParticipant([]);





    }


    // const loadTeams = (id) => {
    //     axiosFetch({
    //         method: "get",
    //         url: `/Lookup/department/teams/${id}`
    //     })
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setTeamList(res.data);
    //             }
    //             // else if (res.status === 400) {
    //             //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
    //             // }
    //             else if (res.status === 401) {
    //                 navigate("/");
    //             }
    //         })
    //         .catch(err => {
    //             console.error(err);
    //         })
    // }

    // const loadDepartments = () => {
    //     axiosFetch({
    //         method: "get",
    //         url: "/Lookup/departments"
    //     })
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 // setDepartmentList(res.data);
    //             }
    //             // else if (res.status === 400) {
    //             //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
    //             // }

    //             else if (res.status === 401) {
    //                 navigate('/');
    //             }
    //         })
    //         .catch(err => {
    //             console.error(err);
    //         })
    // }


    useEffect(() => {

        dispatch(loadDepartments());
        dispatch(loadStatus());
        dispatch(loadUsers());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])




    useEffect(() => {

        if (props && props.request !== undefined && props.request !== null) {

            // if (props.request.departmentId !== null) {
            //     dispatch(loadTeams(props.request.departmentId));
            // }
            if (props.request.assignedUserId !== undefined && props.request.assignedUserId !== null) {
                setSelectedOwner(usersList.filter(user => { return props.request.assignedUserId.split(",").some(owner => { return owner === user.value }) }));
            }
            // else if (props.request.assignedUserId !== undefined && props.request.assignedUserId === null) {
            //     setSelectedOwner([]);
            // }
            console.log(props.request)
            if (props.request.departmentId !== null && departmentList.length !== 0) {

                let selectedVal = departmentList.filter(deparment => deparment.value == props.request.departmentId)[0];
                if (selectedVal === undefined || selectedVal === "undefined") {
                    setSelectedDept(null);
                }
                else {
                    setSelectedDept(selectedVal);
                }
            }
            if (props.request.teamId !== null && teamList.length !== 0) {

                let selectedVal = teamList.filter(team => team.value == props.request.teamId)[0];
                if (selectedVal === undefined || selectedVal === "undefined") {
                    setSelectedTeam(null);
                }
                else {
                    setSelectedTeam(selectedVal);
                }
            }


            if (props.request.participantId !== null) {
                setSelectedParticipant(usersList.filter(user => { return props.request.participantId.split(",").some(participant => { return participant === user.value }) }))
            }

            if (props.request.title !== null) {
                setKeyword(props.request.title);
            }
            else if (props.request.title === null) {
                setKeyword("");
            }
            if (props.request.statusId !== null) {

                let val = statusList.filter(status => status.value === props.request.statusId)[0];
                if (val === undefined || val === "undefined") {
                    setSelectedStatus(null);
                }
                else {
                    setSelectedStatus(val);
                }

            }
            else if (props.request.statusId === null) {
                setSelectedStatus(null);
            }


            if (props.request.isArchived) {
                setIsArchived(props.request.isArchived);
            }
            if (props.request.dateFilter !== null) {
                setSelectedPeriod(period_list.filter(list => list.value === props.request.year + "-" + props.request.dateFilter));
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.request])

    return (
        <React.Fragment>
            <div className='filter'>
                <h3 className='filters'>Filters</h3>
                <ValidatorForm onSubmit={handleSearch}>
                    <Grid container xs={12} spacing={2}>
                        <Grid item xs={3} >
                            <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={usersList} placeholder="Search by Owner" value={selectedOwner} onChange={handleChangeOwner} isMulti={true} />
                        </Grid>
                        <Grid item xs={3} >
                            <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={usersList} placeholder="Search by Participant" value={selectedParticipant} onChange={handleChangeParticipant} isMulti={true} />
                        </Grid>
                        <Grid item xs={3} className="grid-item">
                            <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={statusList} placeholder="Search by Status" value={selectedStatus} onChange={handleChangeStatus} />
                        </Grid>
                        <Grid item xs={3} className="grid-item">
                            <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={departmentList} placeholder="Search by Department" value={selectedDept} onChange={handleChangeDepartment} />
                        </Grid>

                        {selectedDept !== null && <Grid item xs={3} className="grid-item">
                            <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={teamList} placeholder="Search by Team" value={selectedTeam} onChange={handleChangeTeam} />
                        </Grid>}

                        <Grid item xs={3} className="grid-item">
                            <Select menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} options={period_list} placeholder="Select Period" value={selectedPeriod} onChange={handleChangePeriod} />
                        </Grid>
                    </Grid><br />
                    <Grid container xs={12} spacing={2} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                        <Grid item xs={3} className="grid-item">

                            <DatePicker
                                // minDate={moment().toDate()}
                                placeholderText="OKR Ends Before"
                                selected={startDate}
                                onSelect={handleChangeDueDate}
                                dateFormat="yyyy-MM-dd"
                                className="datetime"
                            />

                            {/* <TextValidator
                                onFocus={onFocus_DueDate}
                                onBlur={onBlur_DueDate}
                                label="OKR Ends Before"
                                type={hasValue_DueDate || focus_DueDate ? "date" : "text"}
                                variant="outlined"
                                fullWidth
                                value={startDate}
                                onChange={handleChangeDueDate}
                            /> */}
                        </Grid>
                        <Grid item xs={3} className="grid-item">
                            <TextValidator
                                id="input-with-icon-textfield"
                                variant="outlined"
                                fullWidth
                                label="Find an OKR"
                                value={keyword}
                                onChange={handleChangeKeyword}
                            />
                        </Grid>
                        <Grid item xs={6} className="grid-item filter-label-switch">
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="isArchive"
                                        color="primary"
                                        checked={isArchived}
                                        onChange={toggleArchive}
                                        disabled={isShowArchive}
                                    />
                                }
                                label="Archived OKRs"
                                className='toggled-btn theme-switch'
                                sx={{ '& .MuiFormControlLabel-label': { fontSize: "10px !important" } }}
                            />
                            {/* </Grid> */}
                            {/* <Grid item xs={3} className="grid-item"> */}
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="isPastDueDate"
                                        color="primary"
                                        checked={isDueDatePast}
                                        onChange={togglePastDueDate}
                                        disabled={isShowPast_DueDate}
                                    />
                                }
                                label="Passed Due Dates"
                                className='toggled-btn theme-switch'
                                sx={{ '& .MuiFormControlLabel-label': { fontSize: "10px !important" } }}
                            />
                            <FormControlLabel control={
                                <Checkbox
                                    name="includeKeyResult"
                                    color="primary"
                                    checked={includeKeyResult}
                                    onChange={handleChangeIncludeKeyResult}
                                    disabled={!isDueDatePast}

                                />} label="Include Key Result"
                                sx={{ '& .MuiFormControlLabel-label': { fontSize: "11px !important" }, '.MuiSvgIcon-root': { fontSize: "15px !important" } }}

                            />
                        </Grid>
                        {/* <Grid item xs={4} className="grid-item">
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="isArchive"
                                        color="primary"
                                        checked={isArchived}
                                        onChange={toggleArchive}
                                        className="theme-switch"
                                    />
                                }
                                label="Show Only Archived OKRs"
                                className='toggled-btn'
                            />
                        </Grid> */}
                        {/* <Grid item xs={4} className="grid-item"> */}

                    </Grid>
                    {/* <Grid container xs={12} className="grid-item">
                        
                    </Grid> */}
                    <Grid container xs={12} spacing={2} sx={{ display: "flex", justifyContent: "center", marginTop: "5px" }}>
                        <Grid item xs={6} className="grid-item">
                            <p className="helper-message"> You have got {props.totalRecords} OKRs. Click on a OKR title to track its progress. </p>
                        </Grid>
                        <Grid item xs={6} className="grid-item" justifyContent="flex-end">
                            <Button variant="contained" className='theme-btn org-btn' type="submit">Search</Button>
                            <Button variant="contained" className='theme-btn org-btn cancel-btn' onClick={handleClear}>Clear</Button>
                        </Grid>
                    </Grid>
                </ValidatorForm>

            </div >
        </React.Fragment >
    )
}

export default FilterOKR;